import {TripCollection} from "../Trip";
import zimbri from "../../../assets/child/zimbri.jpg";

const dayChildZimbri: TripCollection = {
    imageSrc: zimbri,
    trips: [
        {
            name: "7.1. Valea Zimbrilor I",
            route: "Braşov – Vama Buzăului – Prejmer – Braşov",
            days: [
                [
                    {
                        locationName: "Rezervaţia de Zimbri",
                    },
                    {
                        locationName: "Biserica Evanghelică Fortificată Prejmer",
                    },
                    {
                        locationName: "Degustare de Clătite",
                    },
                ]
            ],
            notes: "Pornește într-o excursie plină de natură, istorie și tradiții autentice ale Transilvaniei. Prima oprire este la Rezervația de Zimbri din Vama Buzăului, unde vizitatorii pot observa aceste impresionante animale sălbatice în mediul lor natural. Traseul continuă la Biserica Evanghelică Fortificată din Prejmer, monument UNESCO, simbol al comunității săsești și al arhitecturii medievale. Excursia se încheie cu o degustare de clătite tradiționale, oferind un moment delicios de relaxare și descoperire a gusturilor locale."
        },
        {
            name: "7.2. Valea Zimbrilor II",
            route: "Braşov – Vama Buzăului – Întorsura Buzăului – Braşov",
            days: [
                [
                    {
                        locationName: "Rezervaţia de Zimbri",
                    },
                    {
                        locationName: "Grădina cu Struţi",
                    },
                    {
                        locationName: "Atelier de pictură pe ouă de struţ",
                    },
                ]
            ],
            notes: "O excursie care combină natura, tradițiile și experiențele interactive, oferind momente memorabile pentru întreaga familie. Prima oprire este la Rezervația de Zimbri din Vama Buzăului, unde vizitatorii pot admira aceste impresionante animale sălbatice în habitatul lor natural. Traseul continuă la Grădina cu Struți, unde pot fi observate aceste păsări impunătoare și fascinante. Experiența se încheie cu un atelier de pictură pe ouă de struț, un prilej de a descoperi tradițiile locale și de a crea amintiri unice."
        },
    ]
}

export default dayChildZimbri;